import React, { useEffect } from "react";
import { inject, observer } from "mobx-react";
import { ColumnsType } from "antd/lib/table/interface";
import DeletedStore from "../stores/DeletedStore";
import ClearButton from "../components/buttons/clearButton";
import COLUMNS from "../components/tables/deletedTable/config";
import TableWrapper from "../components/declarants/tableWrapper";
import Table from "../components/common/Table";
import { IObjectMap } from "../interfaces/common";
import Settings from "../components/declarants/Settings";
import {
  DELETED_ACTIVE_COLUMNS,
  DELETED_ORDER_COLUMNS,
} from "../constants/settings";
import { Declarant } from "../models/Declarant";
import updateSortingAndFiltersOfColumns from "../helpers/filters";
import Card from "../components/Card/Card";
import SettingsStore from "../stores/SettingsStore";
import UserStore from "../stores/UserStore";
import RefreshButton from "../components/buttons/RefreshButton";

const deletedStore = new DeletedStore();
let isLoaded = false;

const onLoadHandler = (
  parameters?: IObjectMap,
  forceUpdate?: boolean
): void => {
  deletedStore.load(parameters || {}, forceUpdate);
};

const getRowClass = (record: Object) =>
  (record as Declarant).exposed ? "exposed-row" : "";

const DeletedPage: React.FC<{
  settingsStore: SettingsStore;
  userStore: UserStore;
}> = ({ settingsStore, userStore }) => {
  useEffect(() => {
    if (isLoaded) {
      return;
    }

    deletedStore.load({});
    isLoaded = true;
  }, []);

  useEffect(() => {
    settingsStore.setColumns(
      updateSortingAndFiltersOfColumns(
        userStore.authorizedOnly(COLUMNS) || COLUMNS,
        deletedStore.parameters as IObjectMap
      ),
      DELETED_ORDER_COLUMNS,
      DELETED_ACTIVE_COLUMNS
    );
  }, [
    settingsStore,
    userStore,
    settingsStore.isEnabledReorder,
    deletedStore.parameters,
  ]);

  return (
    <Card>
      <Card.Header>
        <ClearButton store={deletedStore} />
        <RefreshButton refresh={deletedStore} />
        <Settings reorderable />
      </Card.Header>
      <TableWrapper enableScrollBar={settingsStore.isEnabledScrollbar}>
        <Table
          rowClassName={getRowClass}
          columns={settingsStore.activeColumns as ColumnsType<object>}
          data={deletedStore.data}
          onLoad={onLoadHandler}
          hasMoreItems={deletedStore.hasMoreItems}
          isLoading={deletedStore.isLoadingTableData}
          settingsStore={settingsStore}
        />
      </TableWrapper>
    </Card>
  );
};

export default inject(({ store }) => ({
  settingsStore: store.settingsStore,
  userStore: store.userStore,
}))(observer(DeletedPage));
